import useAuth from "../../component/useAuth";
import StudentTemplate from "../../component/StudentTemplate";
import { useEffect } from "react";
import Api from "../../component/Api";
import { useState } from "react";
import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "datatables.net";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import $ from "jquery";
import Loader from "../../component/Loader";

export default function PaymentBills() {
  const navigate = useNavigate();
  //validating user credintial again to ensure he is loged in
  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/");
  }

  const tableRef = useRef(null);
  const [payments, setpayments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [Loading, setLoading] = useState(false);
  const [purpose, setPurpose] = useState([]);

  const { http } = Api();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { http } = Api();
        const response = await http.get(`/Student/paymentExamEcopyRevalSlip`);

        setpayments(response.data.result);
      } catch (error) {
        console.error("Error fetching user log data:", error);

        if (error.response) {
          const { status, data } = error.response;

          if (data?.status_code === "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => {
              navigate("/");
            }, 5000);
          } else if (status === 401) {
            toast.error("Invalid Token");
            setTimeout(() => {
              navigate("/");
            }, 5000);
          } else if (status === 500) {
            if (data?.status_code === "ERR5") {
              toast.error(data?.message || "Data not found");
            } else {
              toast.error("Internal Server Error. Please try again later.");
            }
          } else {
            console.error("Unexpected status:", status, data);
            toast.error("An unexpected error occurred.");
          }
        } else if (error.request) {
          console.error("No response received:", error.request);
          toast.error(
            "No response from the server. Please check your connection."
          );
        } else {
          console.error("Request setup error:", error.message);
          toast.error("Request failed to process.");
        }
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (payments.length > 0) {
      if ($.fn.DataTable.isDataTable("#dataTable")) {
        $("#dataTable").DataTable().destroy();
      }
      $("#dataTable").DataTable({
        searching: true,
        info: true,
        pageLength: 50,
        autoWidth: false,
        responsive: true,
        columnDefs: [{ targets: "_all", className: "dt-center" }],
      });
    }
  }, [payments, Loading]);

  const handleDownload = async (examid, transactionId, semester = null) => {
    setLoading(true);
    try {
      // Find the payment item to get the purpose
      const paymentItem = payments.find(
        (payment) =>
          payment.examid === examid && payment.transaction_id === transactionId
      );

      let response;

      if (paymentItem?.purpose === "Supply") {
        // For Supply purpose, use paymentReceipt endpoint
        response = await http.post(
          "/Student/paymentReceiptPdf",
          {
            txnid: transactionId,
            examid: examid,
          },
          {
            responseType: "blob",
          }
        )
      } else if (paymentItem?.purpose === "Condonation") {
        response = await http.post(
          "/Student/paymentCondonationReceiptDownload",
          {
            txnid: transactionId,
            semester: paymentItem.semester ?? semester, // attach semester
          },
          { responseType: "blob" }
        );
      }
      else if (paymentItem?.purpose === "Readmission") {
        response = await http.post(
          "/Student/paymentReadmissionReceiptDownload",
          {
            txnid: transactionId,
            semester: paymentItem.semester ?? semester, // attach semester
          },
          { responseType: "blob" }
        );
      } else {
        // For other purposes, use the original endpoint
        response = await http.post(
          "/Student/paymentRVReceiptPdf",
          {
            examid: examid,
            txnid: transactionId,
          },
          {
            responseType: "blob",
          }
        );
      }

      if (response?.data) {
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = "PaymentReceipt.pdf";
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        link.remove();
        setLoading(false);
        toast.success("PDF generated successfully");
      }
    } catch (error) {
      setLoading(false);
      toast.error("Error generating PDF");
    }
  };

  return (
    <>
      <ToastContainer />
      <StudentTemplate>
        {Loading ? (
          <Loader />
        ) : (
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="card ">
                  <div className="card-header card-heading mobile">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="card-body">
                        <h4 className="card-title text-center font-weight-bold text-black mobile">
                          Transaction History
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="card-body p-0 p-md-3">
                      {/* Desktop view - Table */}
                      <div className="d-none d-md-block">
                        <div class="table-responsive">
                          <table
                            className="table table-striped table-strip-bod table-hover table-bl"
                            id="dataTable"
                            ref={tableRef}
                          >
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    textAlign: "center",
                                    backgroundColor: "black",
                                    color: "white",
                                  }}
                                >
                                  Sl No
                                </th>
                                <th
                                  style={{
                                    textAlign: "center",
                                    backgroundColor: "black",
                                    color: "white",
                                  }}
                                >
                                  Transaction ID
                                </th>
                                <th
                                  style={{
                                    textAlign: "center",
                                    backgroundColor: "black",
                                    color: "white",
                                  }}
                                >
                                  Amount
                                </th>
                                <th
                                  style={{
                                    textAlign: "center",
                                    backgroundColor: "black",
                                    color: "white",
                                  }}
                                >
                                  Status
                                </th>
                                <th
                                  style={{
                                    textAlign: "center",
                                    backgroundColor: "black",
                                    color: "white",
                                  }}
                                >
                                  Purpose
                                </th>
                                <th
                                  style={{
                                    textAlign: "center",
                                    backgroundColor: "black",
                                    color: "white",
                                  }}
                                >
                                  Date
                                </th>
                                <th
                                  style={{
                                    textAlign: "center",
                                    backgroundColor: "black",
                                    color: "white",
                                  }}
                                >
                                  Download
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {payments.length > 0 ? (
                                payments.map((payment, userIndex) => {
                                  const serialNumber =
                                    (currentPage - 1) * 50 + userIndex + 1;
                                  return (
                                    <tr
                                      key={userIndex}
                                      style={{
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      <td
                                        style={{
                                          textAlign: "center",
                                          verticalAlign: "middle",
                                        }}
                                      >
                                        {serialNumber}
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          verticalAlign: "middle",
                                        }}
                                      >
                                        {payment.transaction_id}
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          verticalAlign: "middle",
                                        }}
                                      >
                                        {payment.transamt}
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          verticalAlign: "middle",
                                        }}
                                      >
                                        <span
                                          className={`badge ${
                                            payment.payment_status === "SUCCESS"
                                              ? "bg-success"
                                              : payment.payment_status ===
                                                "Failed"
                                              ? "bg-danger"
                                              : "bg-warning"
                                          }`}
                                        >
                                          {payment.payment_status}
                                        </span>
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          verticalAlign: "middle",
                                        }}
                                      >
                                        {payment.purpose}
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          verticalAlign: "middle",
                                        }}
                                      >
                                        {payment.txtrestme}
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          verticalAlign: "middle",
                                        }}
                                      >
                                        <button
                                          className="btn  btn-primary"
                                          onClick={() =>
                                            handleDownload(
                                              payment.examid,
                                              payment.transaction_id
                                            )
                                          }
                                        >
                                          <i className="icon-download me-1"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan="7" className="text-center">
                                    No data found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {/* Mobile view - Cards */}
                      <div className="d-md-none">
                        {payments.length > 0 ? (
                          payments.map((payment, userIndex) => {
                            const serialNumber =
                              (currentPage - 1) * 50 + userIndex + 1;
                            return (
                              <div key={userIndex}>
                                <div
                                  className="card-header d-flex justify-content-between align-items-center mobile"
                                  style={{ borderRadius: "0px" }}
                                >
                                  <span className="fw-bold">
                                    #{serialNumber}
                                  </span>
                                  <span
                                    className={`badge ${
                                      payment.payment_status === "SUCCESS"
                                        ? "bg-success"
                                        : payment.payment_status === "Failed"
                                        ? "bg-danger"
                                        : "bg-warning"
                                    }`}
                                  >
                                    {payment.payment_status}
                                  </span>
                                </div>
                                <div
                                  className="card-body  "
                                  style={{ borderRadius: "0px" }}
                                >
                                  <div className="row g-2">
                                    <div className="col-6">
                                      <small className="text-muted d-block">
                                        Transaction ID
                                      </small>
                                      <div className="text-truncate">
                                        {payment.transaction_id}
                                      </div>
                                    </div>
                                    <div className="col-6">
                                      <small className="text-muted d-block">
                                        Amount
                                      </small>
                                      <div>{payment.transamt}</div>
                                    </div>
                                    <div className="col-6">
                                      <small className="text-muted d-block">
                                        Purpose
                                      </small>
                                      <div>{payment.purpose}</div>
                                    </div>
                                    <div className="col-6">
                                      <small className="text-muted d-block">
                                        Date
                                      </small>
                                      <div>{payment.txtrestme}</div>
                                    </div>
                                  </div>
                                </div>
                                <div className="card-footer py-2 text-center">
                                  <button
                                    className="btn btn-sm btn-primary"
                                    onClick={() =>
                                      handleDownload(
                                        payment.examid,
                                        payment.transaction_id
                                      )
                                    }
                                  >
                                    <i className="icon-download me-1"></i>{" "}
                                    Download Receipt
                                  </button>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="alert text-center">No data found</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </StudentTemplate>
    </>
  );
}
